// extracted by mini-css-extract-plugin
export default {"wrapperLoader":"Loader_wrapperLoader__hK4IJ","wrapperLoaderShow":"Loader_wrapperLoaderShow__XAPp6","loader":"Loader_loader__j0Tkq"};